
				var addMethods = require("../../../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["addInlineMediaAtEndWorker","addAudioVideoTimeWorker","addImageTimeWorker","createAndCopyDocTimeWorker","createClippedDocWorker","createClippedDocFromLocationWorker","createAndCopyDocLocationWorker"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "b9beba0e53602e6515a0.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			